<div class="modal-header">
  <h3 class="modal-title" id="modal-title">{{ title }}</h3>
  @if (showClose) {
    <button
      type="button"
      class="btn-close"
      aria-label="Close button"
      aria-describedby="modal-title"
      (click)="onModalClose()"
    ></button>
  }
</div>
<div class="modal-body">
  <ng-content select="[modal-body-content]" />
</div>
<div class="modal-footer">
  <ng-content select="[modal-footer-content]" />
</div>
